import React from 'react';

import { ReactComponent as TwitterIcon } from '../../images/twitter-fill-white-gray.svg';
import { ReactComponent as FacebookIcon } from '../../images/facebook-fill-white-gray.svg';
import { ReactComponent as LinkedinIcon } from '../../images/linkedin-fill-white-gray.svg';
import { ReactComponent as YouTubeIcon } from '../../images/youtube-fill-white-gray.svg';
import { ReactComponent as FlickrIcon } from '../../images/flickr-fill-white-gray.svg';

const IconSvg = (Icon) => <Icon width={'100%'} height={'100%'} preserveAspectRatio={'xMidYMid meet'} />;

export const SOCIALS_ICONS = {
  twitter: IconSvg(TwitterIcon),
  facebook: IconSvg(FacebookIcon),
  linkedin: IconSvg(LinkedinIcon),
  youtube: IconSvg(YouTubeIcon),
  flickr: IconSvg(FlickrIcon),
};
